import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAutomationCreateRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-create',
	path: '/jira/servicedesk/projects/:projectKey/settings/automation/blueprint/:blueprintKey',
};
